import { render, staticRenderFns } from "./ShortVideoFollowItem.vue?vue&type=template&id=b6e13598&scoped=true"
import script from "./ShortVideoFollowItem.vue?vue&type=script&lang=js"
export * from "./ShortVideoFollowItem.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoFollowItem.vue?vue&type=style&index=0&id=b6e13598&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e13598",
  null
  
)

export default component.exports